import { faUser } from '@fortawesome/free-regular-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import React from 'react'

import {
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
} from '@/components/ui/dropdown-menu'
import { useAuth } from '@/hooks/useAuth'
import { cn } from '@/lib/utils'

const UserClients: React.FC = () => {
  const { updateClientContext, isClientUser, currentUser } = useAuth()

  return (
    <>
      <DropdownMenuLabel>Client Account</DropdownMenuLabel>

      <DropdownMenuItem
        className={cn({ 'bg-accent': isClientUser })}
        onClick={() => updateClientContext()}
      >
        <FontAwesomeIcon icon={faUser} />
        {currentUser?.fullName}
      </DropdownMenuItem>

      <DropdownMenuSeparator />
    </>
  )
}

export default UserClients
